import { useS4LContext } from '@s4l/react-context'
import type { UseCaseEvent } from '@s4l/stayforlong'
import type { SearchMetadata } from '@s4l/stayforlong/property/domain/SearchMetadata'
import { useCallback, useEffect, useState } from 'react'

export const useSearchMetadata = () => {
  const { domain } = useS4LContext()
  const [searchMetadata, setSearchMetadata] = useState<SearchMetadata>()

  const updateSearchMetadata = useCallback(
    async ({ response }: UseCaseEvent<'SearchFromPartialAndCriteriaPropertyUseCase'>) => {
      const [errorSearch, search] = response

      if (errorSearch) return
      setSearchMetadata(search.metadata)
    },
    []
  )

  useEffect(() => {
    domain.on('SearchFromPartialAndCriteriaPropertyUseCase', updateSearchMetadata)

    return () => {
      domain.off('SearchFromPartialAndCriteriaPropertyUseCase', updateSearchMetadata)
    }
  }, [domain, updateSearchMetadata])

  return {
    searchMetadata,
  }
}
